import React, { useState, useEffect, useCallback } from "react";
import "./EpisodeList.css";
import EpisodeListFilter from "./EpisodeListFilter";
import { useDispatch, useSelector } from "react-redux";
import {
  selectedEpisodeList,
  getFilterEpisodeLists,
  // getEpisodeFilterOptions,
  setEpisodeListFilterObj,
} from "./redux/EpisodeListSlicer";
import { useNavigate, useLocation } from "react-router-dom";
import { Table, Badge, Spinner, Form, Pagination } from "react-bootstrap";
import { Tooltip, Box, Drawer } from "@mui/material";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import RefershIcon from "../../../common/assets/images/reload.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  resetDocumentViewerError,
  resetEpisodeIdentifierTopassDocumentViewer,
  resetDocumentViewerLoadedData,
} from "../../DocumentViewer/redux/DocumentViewerSlicer";
import {
  faSortAmountUp,
  faSortAmountDesc,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { debounce } from "lodash";
import { MdHeight } from "react-icons/md";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import LockOutlineIcon from '@mui/icons-material/LockOutline';

const EpisodeListMobile = ({getInitialFilterState}) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const codebookusaEnv = process.env.REACT_APP_FLAG_USA;

  const permissions = JSON.parse(sessionStorage.getItem("permissions"));
  const permissionList = Object.keys(permissions);

  const { episodeListFilterObj } = useSelector((state) => state.episodeList);
  const {
    episodesFilterList,
    episodesFilterListLoading,
    episodesFilterListError,
  } = useSelector((state) => state.episodeList.viewEpisodesFiltersList);
  const navigate = useNavigate();
  const currentLocation = useLocation(); // <- use a unique name

  const [episodeListRowsPerPage, setEpisodeListRowsPerPage] = useState(10);
  const [episodeListCurrentPage, setEpisodeListCurrentPage] = useState(1);
  const [showepisodeListFilter, setShowepisodeListFilter] = useState(false);
  const [searchType, setSearchType] = useState("episode"); // 'episode' | 'mrn'
  const [showOptions, setShowOptions] = useState(false);
  const [open, setOpen] = useState(false);
  const totalPages =
    typeof episodesFilterList?.total_episodes === "number" &&
    typeof episodeListFilterObj?.page_size === "number" &&
    episodeListFilterObj.page_size > 0
      ? Math.ceil(
          episodesFilterList.total_episodes / episodeListFilterObj.page_size
        )
      : 0;

  const dataToDisplay =
    episodesFilterList?.episode?.length > 0 && episodesFilterList?.episode;
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      const payload = {
        ...episodeListFilterObj,
        page: pageNumber,
      };
      dispatch(setEpisodeListFilterObj(payload));
      dispatch(getFilterEpisodeLists(payload));
      // setEpisodeListCurrentPage(pageNumber);
    }
  };

    useEffect(() => {
      sessionStorage.setItem("trackHistory", JSON.stringify([]));
      sessionStorage.setItem("redoStack", JSON.stringify([]));
      const codeAssistStatusChangePayload = {
        ...getInitialFilterState(),
        module_name: "Code Assist",
      };
  
      const codeAccelerateStatusChangePayload = {
        ...getInitialFilterState(),
        module_name: "Code Accelerate",
      };
  
      if (location.pathname === "/Code-Assist-Episode-list") {
        dispatch(getFilterEpisodeLists(codeAssistStatusChangePayload));
        dispatch(setEpisodeListFilterObj(codeAssistStatusChangePayload));
      } else {
        dispatch(getFilterEpisodeLists(codeAccelerateStatusChangePayload));
        dispatch(setEpisodeListFilterObj(codeAccelerateStatusChangePayload));
      }
    }, [location.pathname]);
  

  const handleRowsPerPageChange = (event) => {
    const payload = {
      ...episodeListFilterObj,
      page: 1,
      page_size: Number(event.target.value),
    };

    dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));
  };

  const sortingEpisodeHandler = (name) => {
    const currentSortBy = episodeListFilterObj.sort_by;
    const currentSortOrder = episodeListFilterObj.sort_order;

    const newSortOrder =
      currentSortBy === name && currentSortOrder === "asc" ? "desc" : "asc";

    const payload = {
      ...episodeListFilterObj,
      sort_by: name,
      sort_order: newSortOrder,
    };

    dispatch(setEpisodeListFilterObj(payload));
    dispatch(getFilterEpisodeLists(payload));
  };

  const getPatientTypeIcon = (patientType) => {
      const type = patientType?.toLowerCase();
  
      if (type?.includes("inpatient") || type === "in-patient") {
        return faBed;
      } else if (type?.includes("outpatient") || type === "out-patient") {
        return faUserInjured;
      }
      return faUser; // default icon
    };


      const getPatientTypeColor = (patientType) => {
    const type = patientType?.toLowerCase();

    if (type?.includes("inpatient") || type === "in-patient") {
      return "#4CAF50";
    } else if (type?.includes("outpatient") || type === "out-patient") {
      return "#2196F3";
    }
    return "#757575";
  };

  const closeEpisodeFilterModal = () => {
    setShowepisodeListFilter(false);
  };
  const toggleDrawer = (state) => () => {
    console.log("entered toggle");
    setOpen(state);
    if (state === true) {
      // dispatch(getEpisodeFilterOptions());
    }
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {["Inbox", "Starred", "Send email", "Drafts"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {["All mail", "Trash", "Spam"].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

    const debounceSearchHandler = useCallback(
        debounce((payload) => {
          dispatch(getFilterEpisodeLists(payload))
        }, 1000),
        []
      );

       const handleSearchTypeChange = (type) => {
          const payload={
        ...episodeListFilterObj,
        episode_identifier:"",
        medical_record_number:""
          }
          setSearchType(type);
          setShowOptions(false);
          dispatch(setEpisodeListFilterObj(payload));
        };
  
     const handleEpisodeIdentiferSearch = (e) => {
        const value = e?.target?.value || "";
    const payload = {
      ...episodeListFilterObj,
      episode_identifier: searchType === "episode" ? value : "",
      medical_record_number: searchType === "mrn" ? value : "",
    };
          dispatch(setEpisodeListFilterObj(payload));
        debounceSearchHandler(payload);
      };


  return (
    <div className="episodelist-section" style={{ height: "50%" }}>
      <div className="episodelist-header">
        <div className="episodelist-header-section">
          <h4 className="episodelist-header-text">Episode List</h4>
          <span className="episodelist-header-text-total">{`(${
            episodesFilterList?.total_episodes
              ? episodesFilterList?.total_episodes
              : 0
          })`}</span>
        </div>
        <div className="episodelist-filter-section">
          <Box sx={{mr: 1}}>
                      <input className="episodelist-filter-episode-identifier" placeholder="Search episode identifer"
                                               value={
  searchType === "episode"
    ? episodeListFilterObj?.episode_identifier
    : episodeListFilterObj?.medical_record_number
}

    placeholder={
      searchType === "episode"
        ? "Search by Episode ID"
        : "Search by MRN"
    }
    onFocus={() => setShowOptions(true)}
    onBlur={() => setTimeout(() => setShowOptions(false), 150)}
              onChange={handleEpisodeIdentiferSearch}
     />
                       {showOptions && (
    <div className="search-options-dropdown">
      <div
  className={`search-option ${searchType === "episode" ? "active" : ""}`}
  onMouseDown={() => handleSearchTypeChange("episode")}
>
  Search by Episode ID
</div>

<div
  className={`search-option ${searchType === "mrn" ? "active" : ""}`}
  onMouseDown={() => handleSearchTypeChange("mrn")}
>
  Search by MRN
</div>

    </div>
  )}
                    </Box>
          {/* {permissionList?.includes("admin") &&
            (permissionList?.includes("Code Accelerate") ||
              permissionList?.includes("Code Assist")) && (
              <Button>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#4999C9",
                    mr: 1,
                    borderRadius: "10px",
                    fontSize: "12px",
                    display: " flex",
                    alignItems: "center",
                  }}
                  onClick={() => navigate("/upload-document")}
                >
                  Upload your own documents
                  <UploadFileIcon style={{ height: "15px" }} />
                </Button>
              </Button>
            )} */}
          {/* <Button variant="contained" sx={{backgroundColor: "#4999C9", mr:1, borderRadius: '10px', fontSize: "12px", display:" flex", alignItems: 'center'}} onClick={() => navigate("/upload-document")}>
                                            Upload your own documents
                                            <UploadFileIcon  />
                                           </Button> */}
                                           
          <span
            class="episodelist-refresh-btn"
            onClick={() => window.location.reload()}
          >
            {/* <span> */}
              <img src={RefershIcon} alt="img" />
            {/* </span> */}
          </span>
          {/* <button
  className="episodelist-filter-btn"
  onClick={toggleDrawer(true)} // ✅ Correct
>
  Filters
</button> */}
          <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
            {DrawerList}
          </Drawer>
          <button
            className="episodelist-filter-btn"
            onClick={() => {
              setShowepisodeListFilter(!showepisodeListFilter);
              // dispatch(getEpisodeFilterOptions());
            }}
          >
            Filters
          </button>
        </div>
      </div>
      <div
        className="episodelist-table-container"
        style={{ overflowX: "auto" }}
      >
        <Table
          // responsive="sm"
          style={{ textAlign: "center" }}
          className={`${
            episodesFilterList?.episode?.length <= 0 ||
            episodesFilterList?.episode?.length === undefined ||
            episodesFilterListLoading ||
            episodesFilterListError
              ? "episodelist-filter-table-loading"
              : "episodelist-filter-table"
          }`}
        >
          <thead className="episodelist-thead">
            <tr className="episodelist-tr">
              {codebookusaEnv && (
                <th className="episodelist-th">
                  <div>
                    <span>Episode Type</span>
                  </div>
                </th>
              )}
              <th
                className="episodelist-th"
                style={{ position: "sticky", left: 0, zIndex: 50 }}
              >
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("medical_record_number")}
                >
                  <div>
                    <span>MRN/UR</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "medical_record_number" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by ===
                        "medical_record_number" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("episode_identifier")}
                >
                  <div>
                    <span> Episode Number</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "episode_identifier" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "episode_identifier" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("admission_date")}
                >
                  <div>
                    <span>Admission Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "admission_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "admission_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("separation_date")}
                >
                  <div>
                    <span>Discharge Date</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "separation_date" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "separation_date" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("length_of_stay")}
                >
                  <div>
                    <span>LOS</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "length_of_stay" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "length_of_stay" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th">
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("speciality")}
                >
                  <div>
                    <span>Speciality</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "speciality" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "speciality" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {/* <th className="episodelist-th">
                <div className="episodelist-th-container" onClick={() => sortingEpisodeHandler("created_at")}>
                  <div>
                    <span>Created At</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "asc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : episodeListFilterObj.sort_by === "created_at" && episodeListFilterObj.sort_order === "desc" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                    <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountUp}  /></span>
                    ) : <span className="episodelist-sort-icon"><FontAwesomeIcon icon={faSortAmountDesc}  /></span>
                    }
                  </div>
                </div>
              </th> */}

              <th className="episodelist-th" style={{ minWidth: "100px" }}>
                <div
                  className="episodelist-th-container"
                  onClick={() => sortingEpisodeHandler("drg")}
                >
                  <div>
                    <span>Drg</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "drg" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "drg" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              <th className="episodelist-th" style={{ minWidth: "200px" }}>
                <div
                  className="episodelist-th-container-status"
                  onClick={() => sortingEpisodeHandler("status")}
                >
                  <div>
                    <span>Status</span>
                  </div>
                  <div>
                    {episodeListFilterObj.sort_by === "status" &&
                    episodeListFilterObj.sort_order === "asc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "status" &&
                      episodeListFilterObj.sort_order === "desc" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    ) : episodeListFilterObj.sort_by === "" ? (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountUp} />
                      </span>
                    ) : (
                      <span className="episodelist-sort-icon">
                        <FontAwesomeIcon icon={faSortAmountDesc} />
                      </span>
                    )}
                  </div>
                </div>
              </th>
              {location.pathname != "/Code-Assist-Episode-list" && (
                <th className="episodelist-th">
                  <div
                    className="episodelist-th-container"
                    onClick={() => sortingEpisodeHandler("no_of_documents")}
                  >
                    <div>
                      <span>No of documents</span>
                    </div>
                    <div>
                      {episodeListFilterObj.sort_by === "no_of_documents" &&
                      episodeListFilterObj.sort_order === "asc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "no_of_documents" &&
                        episodeListFilterObj.sort_order === "desc" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      ) : episodeListFilterObj.sort_by === "" ? (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountUp} />
                        </span>
                      ) : (
                        <span className="episodelist-sort-icon">
                          <FontAwesomeIcon icon={faSortAmountDesc} />
                        </span>
                      )}
                    </div>
                  </div>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {episodesFilterListLoading ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  <Spinner />{" "}
                </div>
              </td>
            ) : episodesFilterListError ? (
              <td colspan="10">
                <div className="episodelist-table-loader">
                  Something went wrong
                </div>
              </td>
            ) : dataToDisplay?.length > 0 ? (
              dataToDisplay?.map((episode) => {
                return (
                  <tr
                    key={episode.episode_number}
                    onClick={() => {
                      // navigate("/coder");
                      const currentPath = currentLocation.pathname;
                      const destinationPath =
                        currentPath === "/Code-Assist-Episode-list"
                          ? "/Code-Assist"
                          : "/coder";

                      navigate(destinationPath);
                      dispatch(resetEpisodeIdentifierTopassDocumentViewer());
                      sessionStorage.setItem("currentPage", "episodeList");
                      sessionStorage.setItem(
                        "filters",
                        JSON.stringify(episodeListFilterObj),
                      );
                      dispatch(resetDocumentViewerLoadedData());
                      dispatch(selectedEpisodeList(episode));
                      dispatch(resetDocumentViewerError());
                    }}
                  >
                    {codebookusaEnv && (
                      <td className="episodelist-td">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          {episode?.type_patient ? (
                            <>
                              <Tooltip title={episode.type_patient}>
                                <FontAwesomeIcon
                                  icon={getPatientTypeIcon(
                                    episode.type_patient,
                                  )}
                                  style={{
                                    color: getPatientTypeColor(
                                      episode.type_patient,
                                    ),
                                    fontSize: "16px",
                                  }}
                                />
                              </Tooltip>
                              <span style={{ marginLeft: "4px" }}>
                                {/* {episode.type_patient} */}
                                {episode.type_patient.charAt(0).toUpperCase() +
                                  episode.type_patient.slice(1)}
                              </span>
                            </>
                          ) : (
                            <>
                              <FontAwesomeIcon
                                icon={faUser}
                                style={{
                                  color: "#757575",
                                  fontSize: "16px",
                                }}
                              />
                              <span style={{ marginLeft: "4px" }}>-</span>
                            </>
                          )}
                        </div>
                      </td>
                    )}
                    <td
                      className="episodelist-td"
                      style={{ position: "sticky", left: 0 }}
                    >
                      {episode.is_locked && (
                        <LockOutlineIcon
                          style={{ fontSize: "14px", marginRight: "4px" }}
                        />
                      )}
                      <Tooltip title={episode.medical_record_number}>
                        {episode.medical_record_number
                          ? episode.medical_record_number
                          : "-"}
                      </Tooltip>
                    </td>
                    <td className="episodelist-td">
                      {episode.episode_identifier
                        ? episode.episode_identifier
                        : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.admission_date ? episode.admission_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.separation_date ? episode.separation_date : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.length_of_stay ? episode.length_of_stay : "-"}
                    </td>
                    <td className="episodelist-td">
                      {episode.speciality ? episode.speciality : "-"}
                    </td>
                    {/* <td className="episodelist-td">
                      {episode.created_at ? episode.created_at : "-"}
                    </td> */}
                    <td
                      className={`episodelist-td ${
                        episode.status === "Coding Complete" ||
                        episode.status === "aCS Coding Complete"
                          ? "episodelist-td-min-bold-drg"
                          : episode.status === "AI codes awaiting validation" &&
                              episode.drg !== "No DRG"
                            ? "episodelist-td-bold-drg"
                            : "episodelist-td-normal-drg"
                      }`}
                    >
                      {/* <td className={`episodelist-td ${episode.status === "Coding Complete" ? "Coding Complete" : episode.status === "aCS Coding Complete" ? "aCS Coding Complete" : episode.status === "AI processing complete - codes available for validation" ? "episodelist-td-bold-drg" : "episodelist-td-normal-drg"}`}> */}
                      {episode.drg ? episode.drg : "-"}
                    </td>
                     <td className="episodelist-td-status">
  {(() => {
    const rawStatus = episode?.status;
    const statusArray = Array.isArray(rawStatus)
      ? rawStatus
      : rawStatus
        ? [rawStatus]
        : [];

    const statuses = statusArray.filter(Boolean).map((item) =>
      typeof item === "string"
        ? { status: item, display_value: item, is_primary: false }
        : item,
    );

    if (statuses.length === 0) {
      return <span>-</span>;
    }

    const primaryStatus =
      statuses.find((item) => item?.is_primary) || statuses[0];

    const secondaryStatuses = statuses.filter((item) => item !== primaryStatus);

    const label =
      primaryStatus?.display_value || primaryStatus?.status || "-";

    return (
      <Tooltip
        title={
          <div style={{ padding: "4px 8px" }}>
            {statuses.map((item, index) => (
              <div key={index}>{item?.display_value || item?.status || "-"}</div>
            ))}
          </div>
        }
        arrow
        placement="top"
      >
        <Box>
          <div
            style={{
              position: "relative",
              width: "100%",
              cursor: statuses.length > 1 ? "pointer" : "default",
            }}
          >
            {secondaryStatuses.slice(0, 2).map((_, index) => (
              <div
                key={index}
                style={{
                  position: "absolute",
                  top: `${(index + 1) * 3}px`,
                  left: `${(index + 1) * 3}px`,
                  right: `${-(index + 1) * 3}px`,
                  bottom: `${-(index + 1) * 3}px`,
                  backgroundColor: "#d1d5db",
                  borderRadius: "6px",
                  zIndex: index,
                  opacity: 0.6,
                }}
              />
            ))}

            <Badge
              style={{
                backgroundColor: episode?.status_color || "#dbeafe",
                color:
                  label === "AI codes awaiting validation" ? "white" : "#344054",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "30px",
                width: "100%",
                fontSize: "10px",
                whiteSpace: "normal",
                overflow: "hidden",
                textOverflow: "ellipsis",
                borderRadius: "6px",
              }}
            >
              {label}
            </Badge>
          </div>
        </Box>
      </Tooltip>
    );
  })()}
</td>
                    {location.pathname != "/Code-Assist-Episode-list" && (
                      <td className="episodelist-td">
                        {episode?.document_count > 0
                          ? episode?.document_count
                          : 0}
                      </td>
                    )}
                    {/* <td className='episodelist-td'> <Badge style={{ backgroundColor: `${episode?.status_color} !important`  || "#defaultColor !important" }}>{episode.status ? episode.status : "-"}</Badge></td> */}
                    {/* <td className='episodelist-td'>{episode.priority ? episode.priority : "N/A"}</td> */}
                  </tr>
                );
              })
            ) : (
              <td colspan="10">
                <div className="episodelist-table-loader">No Records Found</div>
              </td>
            )}
          </tbody>
        </Table>
      </div>
      <div className="episodelist-footer">
        <div>
          <Pagination size="sm" className="episodelist-pagination">
            <Pagination.First
              onClick={() => handlePageChange(1)}
              disabled={episodeListFilterObj?.page <= 1}
            />
            <Pagination.Prev
              onClick={() => handlePageChange(episodeListFilterObj?.page - 1)}
              disabled={episodeListFilterObj?.page <= 1}
              className="episodelist-prev-btn"
            />
            <Pagination.Item>
              Page {episodeListFilterObj?.page} of {totalPages}
            </Pagination.Item>

            <Pagination.Next
              onClick={() => handlePageChange(episodeListFilterObj?.page + 1)}
              disabled={episodeListFilterObj?.page >= totalPages}
              className="episodelist-next-btn"
            />
            <Pagination.Last
              onClick={() => handlePageChange(totalPages)}
              disabled={episodeListFilterObj.page === totalPages}
            />
          </Pagination>
        </div>
        <div
          className="episodelist-row-options"
          style={{ marginBottom: "5px" }}
        >
          <Form.Select
            size="sm"
            className="episodelist-select"
            value={episodeListFilterObj.page_size}
            onChange={handleRowsPerPageChange}
          >
            <option value="" disabled className="episodelist-rows-per-page">
              Rows per page
            </option>
            {/* <option value={10} className="episodelist-rows-per-page">10</option> */}
            <option value={20} className="episodelist-rows-per-page">
              20
            </option>
            <option value={50} className="episodelist-rows-per-page">
              50
            </option>
            <option value={100} className="episodelist-rows-per-page">
              100
            </option>
          </Form.Select>
        </div>
      </div>
      <EpisodeListFilter
        showepisodeListFilter={showepisodeListFilter}
        setShowepisodeListFilter={setShowepisodeListFilter}
        closeEpisodeFilterModal={closeEpisodeFilterModal}
      />
    </div>
  );
};

export default EpisodeListMobile;
